module.exports = __webpack_public_path__ + "img/pic_351251_3.14b63ba5.jpg";